import { ESIM_STATUS_KEYS, getEsimProfileStatusLabel } from "../../../utils/esim/esimStatus";
import { FilterOption } from "../../reservation_v2/filters/reservationFilters";

/**
 * Filters of the eSIM reservations list (`/esim/reservations`). Same model as the ticket list:
 * every filter lives in the URL under the key below, survives a reload, can be shared as a link,
 * and sends the list back to page 1. `EsimFilterBar` writes them, `EsimReservations` reads them
 * into the `v1/Esim/Reservations` request (backend: EsimReservationsFilterDto).
 */
export const ESIM_FILTER_KEYS = {
  search: "searchkeyword",
  status: "status",
  // Purchase date; the shared date chip writes these two names.
  dateFrom: "dateFrom",
  dateTo: "dateTo",
  // Name kept beside the id only to label the chip after a reload; the API gets the id.
  zoneId: "locationZoneId",
  zoneName: "zoneName",
  packageId: "packageTemplateId",
  packageName: "packageName",
  paymentMethodId: "paymentMethodId",
  // Comma-separated channel group keys (ESIM_CHANNEL_GROUPS), sent to the API as they are.
  channels: "channelGroups",
  type: "isTopUp",
  esimStatus: "esimStatus",
  bus: "withBusReservation"
};

export const ESIM_FILTER_KEY_LIST = Object.values(ESIM_FILTER_KEYS);

/**
 * Where the eSIM came from. The values are group keys the backend resolves
 * (Core/Constants/EsimChannelGroupConstants.cs): it decides which stored channels each one means,
 * because some are not fixed values (a Mall gift carries its order id, a partner eSIM the partner's
 * company name). A new channel is therefore a backend change only.
 */
export const ESIM_CHANNEL_GROUPS: FilterOption[] = [
  { label: "Web", value: "web" },
  { label: "Aplikacioni", value: "app" },
  { label: "Admin", value: "admin" },
  { label: "GjirafaMall", value: "mall" },
  { label: "Vaucher", value: "voucher" },
  { label: "Partner", value: "partner" },
  { label: "Promo e instalimit të app-it", value: "installpromo" },
  { label: "Shpërblim për kartën", value: "cardsave" },
  { label: "Kod QR", value: "claimqr" },
  { label: "GjirafaBox", value: "gjirafabox" }
];

export const ESIM_TYPE_OPTIONS: FilterOption[] = [
  { label: "Blerje e re", value: "false" },
  { label: "Top Up", value: "true" }
];

/** The profile status as the OCS reports it, labelled as on the reservation cards. */
export const ESIM_PROFILE_STATUS_OPTIONS: FilterOption[] = ESIM_STATUS_KEYS.map((status) => ({
  label: getEsimProfileStatusLabel(status),
  value: status
}));

export const ESIM_BUS_OPTIONS: FilterOption[] = [
  { label: "Me biletë autobusi", value: "true" },
  { label: "Pa biletë autobusi", value: "false" }
];
